import * as React from "react";
import { ElementType, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLElement> {
  itemSelector: string;
  children: React.ReactNode;
  as?: ElementType;
}

class LogoMarquee extends React.Component<Props, never> {
  private containerRef: any;

  constructor(props: Props) {
    super(props);
    this.containerRef = React.createRef<HTMLElement>();
  }

  componentDidMount() {
    const container: HTMLElement = this.containerRef.current as HTMLElement;
    const items = container.querySelectorAll(`.${this.props.itemSelector}`);
    const numItems:number = items.length;
    const duration:number = 10;
    
    if(!container) {
      return;
    }

    // set up the animation duration and clone the nodes 
    // activation of the actual animation is taken care of by the resize observer 
    container.style.animationDuration = `${numItems * duration}s`;

    items.forEach(item => {
      const clone: HTMLElement = item.cloneNode(true) as HTMLElement;
      clone.classList.add(`${this.props.itemSelector}--cloned`);
      container.appendChild(clone);
    });
  }

  render(): React.ReactNode {
    const { 
      children,
      as,
    } = this.props;

    let Tag:ElementType = 'div';
    let htmlProps:any = {...this.props};

    if(as) { 
      Tag = as;
      delete htmlProps['as'];
    };

    delete htmlProps['itemSelector'];

    return (
      <Tag {...htmlProps} ref={this.containerRef as React.RefObject<HTMLElement>}>
        { children }
      </Tag>
    )
  }
}

export default LogoMarquee;